<template>
  <illustration-layout :cclink="cclink">
    <div>
      <div>
        <div style="text-align:center;background-color:#8b6f4c;padding:20px">
          <div style="color:#c7c7c7;font-weight:500;font-size:56px">
            {{ heading }}
          </div>
          <div style="color:#ffffff;font-size:48px;margin-bottom:5px">
            {{ artist.formatted_name }}
          </div>
        </div>
        <a :href="leadLink"><img :src="mainBackgroundImage" width="590"></a>
        <div style="text-align:center;background-color:#ffffff;padding:20px" v-if="item.show_artists && pfimage">
          <div style="display:inline-block;border-radius:50%;overflow:hidden;width:90px;height:90px;position:relative;vertical-align:top" >
            <img :src="pfimage" style="width:90px;height:90px;position:absolute;top:0;left:0">
          </div>
        </div>
        <div style="text-align:center;margin:20px 0">
            <a bgcolor="#ce0e2d" style="padding:5px 12px;color:#fff;text-decoration:none;background-color:#ce0e2d;border-radius:6px;display:inline-block" 
              :href="$host + '/artists/' + artist.portfolio_url + ntlink">view {{ firstName }}'s portfolio</a>
        </div>
          
      </div>
      <div style="font-size:19px;margin-top:25px;text-align:center;border-bottom:1px solid #7a7157;margin:35px 35px 0 35px;padding-bottom:35px" v-html="profileText"></div>
      
    </div>
  </illustration-layout>
</template>

<script>
import NewTalentLoader from '../mixins/NewTalentLoader'
import IllustrationLayout from '../layouts/IllustrationLayout.vue'
export default {
  components: {
    IllustrationLayout
  },
  mixins: [ NewTalentLoader ],
  data () {
    return {
      heading: '',
      artist: {},
      profileText: '',
      mainBackgroundImage: '',
      cclink: this.$store.state.cclink + 'NEWTALENT'
    }
  },
  computed: {
    pfimage () {
      if(this.artist && this.artist.formatted_name) {
        return this.$imagehost + '/images/artist/' + this.artist.portfolio_url + '/profile/crop/320/' + this.artist.portfolio_url + '.jpg'
      }
      return ''
    },
    firstName () {
      if(this.artist) {
        if(this.artist.formatted_name) {
          return this.artist.formatted_name.split(' ').slice(0, 1)[0]
        }
        return ''
      }
      return ''
    },
    ntlink () {
      let ntlink = this.cclink
      if(this.artist) {
        if(this.artist.formatted_name) {
          ntlink = this.cclink + '&utm_content=' + encodeURIComponent(this.artist.formatted_name)
        }
      }
      return ntlink
    },
    leadLink () {
      if(this.artist.image_1_link) {
        return this.artist.image_1_link + this.ntlink
      }
      return this.$host + '/artists/' + this.artist.portfolio_url + this.ntlink
    }
  },
  methods: {
    getButtonHtml(imagelink, url) {
      //let imlink = imagelink.replace(/illustrationweb/g, 'illustrationx')
      let murl = url.replace('view?image_id=', '')
      murl += this.ntlink
      return `<a href="${murl}"><img src="${this.$imagehost}/${imagelink}" style="width:520px;display:block;margin:25px 0" width="520" /></a><div 
      style="text-align:center;margin-top:24px">
      <a style="padding:5px 12px;color:#fff;text-decoration:none;background-color:#ce0e2d;border-radius:6px;display:inline-block" 
        href="${this.$host}/artists/${this.artist.portfolio_url}${this.ntlink}">view ${this.firstName}'s portfolio</a>
    </div>`
    },
    formatText(text) {
      return text.replace(/\r/g, '<br/>')
    },
    async loadData() {
      let res = await this.$apix.get(`collections/newtalent/${this.id}`)
      this.item = res.data
      
      if(this.item.artists.length > 0) {
        this.artist = this.item.artists[0]
      }
      if(this.item.subcategory === 'profile') {
        this.heading = 'Illustrator Profile'
        this.cclink = this.$store.state.cclink + 'ILLUSTRATOR_PROFILE'
      }
      else {
        this.heading = 'New Talent Profile'
      }
      let ims = []
      ims.push('')
      ims.push(this.getButtonHtml(this.artist.image_2, this.artist.image_2_link))
      if(this.artist.image_3){
        
        ims.push(this.getButtonHtml(this.artist.image_3, this.artist.image_3_link))
      }
      let profiles = this.artist.profile.split('\r\n')
      let rs = []
      let ctr = 0
      for(let each of profiles) {
        if(ctr < ims.length){
          if(each.startsWith('<h3>')){
            rs.push(ims[ctr++])
          }
        }
        
        rs.push(each)
      }
      this.profileText = rs.join('<br>\n')
      this.mainBackgroundImage = this.$imagehost + '/' + this.artist.image_1
    }
  }
}
</script>

<style>
h3 {
  font-size:30px;
  color:#7a7157;
  margin:0;
  font-weight:500;
}
</style>